  <div class="clvLoginModal d-flex">
    <!--     imagen -->
    <div class="modal-bgImg">
      <img alt="ClaveWinds" class='logosize' [src]="logoPath" style="width:100px;">
    </div>
    <!--     Sign In -->
    <div class="modal-content">
      <div class="modal-body">
        <!--     tabs -->

        <ul class="nav nav-pills nav-fill mb-3" role="tablist" id="pills-tab">
          <li class="nav-item" role="presentation">
            <a class="nav-link nav-logclv active" data-toggle="tab" data-target="#signIn" id="signIn-tab" href="#signIn">
              Identificate
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link nav-logclv" data-toggle="tab" data-target="#signUp" id="signUp-tab" href="#signUp">
              Registrate
            </a>
          </li>
        </ul>

        <div class="tab-content" id="pills-tabContent">

          <div class="tab-pane fade show active" id="signIn" aria-labelledby="signIn-tab" role="tabpanel">
            <h4>Inicia sesión</h4>
  
            <form [formGroup]="formLogin">
              <div class="form-group">
                <label class="small" for="emailLogin">Correo electrónico</label>
                <input formControlName="email" type="email" class="form-control" id="emailLogin" placeholder="nombre@email.com" aria-describedby="emailHelp">
              </div>

              <label class="small" for="inputPassword">Contraseña</label>

              <div class="input-group">
                <input  formControlName="password" [type]="passwordFieldType" class="form-control" id="inputPassword" placeholder="********"  (keydown.enter)="Login()">

                <div class="input-group-append">
                  <span class="input-group-text" (click)="togglePassword()">
                    <i class="bx" 
                      [ngClass]="{'bx-show': passwordFieldType === 'password', 
                                  'bx-hide': passwordFieldType === 'text'}"></i>
                  </span>
                </div>

              </div>

              <a  (click)="goToReset()"  class="small" >¿Olvidaste tu contraseña?</a>
  
              <button  (click)="Login()" [disabled]="formLogin.invalid" type="button" class="btn btn-primary btn-block mt-3">Ingresar</button>
  
              <hr id="lineOr">
  
              <div class="d-flex justify-content-center align-content-center mb-3" style="gap:10px;">
  
               <asl-google-signin-button
                    size="large"
                    text="signin_with"
                    shape="pill"
                    theme="outline"
                    type="icon">
                </asl-google-signin-button>
  
                <span type="button" (click)="signInWithFB()" data-placement="bottom" title="Iniciar sesión con Facebook" class="socialLogin">
                  <i class='bx bxl-facebook bx-sm'></i>
                </span>
  
              </div>
            </form>
          </div>
          <!-- show content sign up -->
          <div class="tab-pane fade" aria-labelledby="signUp-tab" id="signUp" role="tabpanel">
            <h4>Crea tu cuenta</h4>
  
            <form [formGroup]="formGroup">
              <div class="form-group">
                <label class="small" for="name">Nombre</label>
                <input formControlName="name" type="text" class="form-control" id="name" placeholder="Nombre" name="name" aria-describedby="nameHelp">
              </div>
              <div class="form-group">
                <label class="small" for="inputEmail2">Correo electrónico</label>
                <input formControlName="email" type="email" class="form-control" id="inputEmail2" placeholder="nombre@email.com">
              </div>

              <label class="small" for="inputPassword">Contraseña</label>

              <div class="input-group">
                <input formControlName="password" [type]="passwordFieldType" class="form-control" id="inputPassword" placeholder="********" (keydown.enter)="Login()">

                <div class="input-group-append">
                  <span class="input-group-text" (click)="togglePassword()">
                    <i class="bx" 
                      [ngClass]="{'bx-show': passwordFieldType === 'password', 
                                  'bx-hide': passwordFieldType === 'text'}"></i>
                  </span>
                </div>
              </div>
              
              <label class="small" for="inputPasswordConfirm">Confirma la contraseña</label>

              <div class="input-group">

                <input formControlName="confirmpassword" type="password" class="form-control" id="inputPasswordConfirm" placeholder="********">

                <div class="input-group-append">
                  <span class="input-group-text" (click)="togglePassword()">
                    <i class="bx" 
                      [ngClass]="{'bx-show': passwordFieldType === 'password', 
                                  'bx-hide': passwordFieldType === 'text'}"></i>
                  </span>
                </div>

              </div>
              <button (click)="Registro()" [disabled]="formGroup.invalid" type="button" class="btn btn-primary btn-block mt-3">Crear mi cuenta</button>
            </form>       
          </div>

        </div>
        <!--         show content login -->

      </div>
    </div>

  </div>

